'use client';

import type { MouseEvent } from 'react';

import { CircularProgress, Button as ButtonMUI } from '@mui/material';

import { getLoaderSize } from './button.styled';

import type { TButtonProps } from './button.type';

export const Button = ({
  handleClick,
  children,
  disabled = false,
  'aria-label': ariaLabel,
  type = 'button',
  color = 'primary',
  endIcon,
  fullWidth = false,
  size = 'medium',
  startIcon,
  variant = 'outlined',
  className = '',
  loading = false,
  sx = {},
}: TButtonProps) => (
  <ButtonMUI
    type={type}
    onClick={(e: MouseEvent<HTMLButtonElement>) => handleClick && handleClick(e)}
    disabled={loading || disabled}
    aria-label={ariaLabel}
    color={color}
    endIcon={
      loading ? (
        <CircularProgress aria-label="Button loader" color={color} size={getLoaderSize(size)} />
      ) : (
        endIcon
      )
    }
    fullWidth={fullWidth}
    size={size}
    startIcon={startIcon}
    variant={variant}
    className={className}
    sx={{
      ...(size === 'large' && { minHeight: '52px' }),
      ...(variant === 'text' && { fontWeight: 700 }),
      ...sx,
    }}
  >
    {children}
  </ButtonMUI>
);
